import React from "react";
import svg83 from "../../assets/svg/svg83.svg";
import svg84 from "../../assets/svg/svg84.svg";
import svg85 from "../../assets/svg/svg85.svg";
import svg86 from "../../assets/svg/svg86.svg"; 

import { Rate } from "antd";

const items = [
  {
    desc: "Switching to Ndovu Pay has transformed how we manage our day-to-day financial operations. Our teams have more control, and the ease of making secure payments has streamlined our workflow tremendously.",
    svg: svg84,
    name: "Sarah Mwangi",
    department: "Finance Manager at Syntel Africa",
  },
  {
    desc: "Thanks to Ndovu Pay, now I can easily manage my business finances, pay employees, and track expenses from anywhere.It is a must-have tool for entrepreneurs.",
    svg: svg85,
    name: "James Mburu",
    department: "Business Owner",
  },
  {
    desc: "Thanks to Ndovu Pay, we can keep our cash flow steady and stay on top of our vendor payments. It’s a game-changer for our business!",
    svg: svg86,
    name: "Peter Otieno",
    department: "Operations Manager at WEA Enterprise",
  },
 
];
function Testimonial() {
  return (
    <>
      <div className="flex flex-col text-center justify-center items-center ">
        <div className="text-[#342F4D] text-[1.125rem] font-[500] leading-[1.625rem]">
          Testimonial
        </div>
        <div className="mt-[1.13rem] text-[#1E191B] text-[1.875rem] font-[600] leading-[2.25rem]">
          Hear From Our Happy Clients
        </div>
      </div>

      <div className="grid lg:grid-cols-3 grid-cols-1 gap-[1.88rem] mt-[4rem] items-stretch">
        {items &&
          items?.map((item) => (
            <div className="testimonial-card px-[1.87rem] pt-[3.75rem] pb-[6rem] relative h-full">
              <div className="absolute -top-[1.6875rem] left-[1.87rem] h-[3.375rem] w-[3.375rem] rounded-full bg-[#000] flex items-center justify-center">
                <img src={svg83} alt="quote icon"  />
              </div>
              <Rate value={5} />
              <div className="mt-[.98rem] text-[#7A7493] text-[1rem] font-[400] leading-[1.625rem] lg:max-w-[20.875rem] w-full">
                {item?.desc}
              </div>

              <div className="absolute bottom-[2.31rem] left-[1.87rem] right-[1.87rem] flex items-center gap-[.75rem]">
                <div className="w-[2.25rem] h-[2.25rem] flex items-center justify-center rounded-full">
                  <img src={item?.svg} alt={item?.svg} />
                </div>
                <div className="flex flex-col">
                  <span className="text-[#1E191B] text-[1.125rem] font-[500] leading-[1.625rem]">
                    {item?.name}
                  </span>
                  <span className="text-[#7A7493] text-[0.8125rem] font-[400] leading-[1.25rem]">
                    {item?.department}
                  </span>
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  );
}

export default Testimonial;
